import { useQuery } from '@apollo/client';
import { GET_ME } from '../graphql/getMe';
import { Role } from '../__generated__/graphql';

export const useAuthenticated = () => {
  const { data: me, loading } = useQuery(GET_ME);

  const isAuthenticated = Boolean(me?.getMe);
  const isUser = me?.getMe?.role === Role.User;
  const isAdmin = me?.getMe?.role === Role.Admin;
  const isVerified = me?.getMe?.isVerified;
  const hasFingerprint = me?.getMe?.hasFingerprint;
  const isValidFingerprint = me?.getMe?.isValidFingerprint;
  const isGoogleAuth = me?.getMe?.isGoogleAuth;
  const isPlanActive = me?.getMe?.planExpiresAt && new Date(me.getMe.planExpiresAt) > new Date();
  const userName = me?.getMe?.name;

  return {
    isAuthenticated,
    isUser,
    isAdmin,
    isVerified,
    isGoogleAuth,
    isPlanActive,
    hasFingerprint,
    isValidFingerprint,
    userName,
    loading,
  };
}; 